import { z } from "zod";
import { multiLanguageStringSchema } from "../../../backend/types/multiLanguageString";

export const multiLanguageString = (multiLanguageArray: z.infer<typeof multiLanguageStringSchema> | undefined) => {
  if (typeof multiLanguageArray === "undefined") return "";
  
  return multiLanguageArray.find((item) => item.lang === "it")?.string || "";
};
